import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../components/pdf/Preview'
import PdfDocument from './PdfDocument'

const PageContent = ({ templateId }) => {
  return (
    <>
      <PdfOptionsFormHandler initialState={{ fontBaseColor: '#333' }}>
        <Grid align="stretch">
          <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 4.8rem)">
            <Preview>
              <PdfDocument />
            </Preview>
          </Col>
        </Grid>
      </PdfOptionsFormHandler>
    </>
  )
}

export default PageContent
